var Marionette = require('marionette')
var $ = require('jquery')

module.exports = Marionette.ItemView.extend({
  template: false,

  ui: {
    button: '.js-scrollto'
  },

  options: {
    scrollTop: false,
    animationSpeed: 500,
    intervalId: 0
  },

  events: {
    'click @ui.button': 'scrollToTop'
  },

  scrollStep: function () {
    // If top of the page, stop the scrolling
    if (
      (window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop) === 0
    ) {
      clearInterval(this.intervalId)
    }

    $('html, body').animate({ scrollTop: 0 })
  },

  scrollToTop: function () {
    // Initialize the function every 16 milliseconds
    this.intervalId = setInterval(this.scrollStep(), 16.66)
  }
})
